import types from './types';

const INITIAL_STATE = {
  isFetchingClaim: false,
  isFetchingSubmitted: false,
  isFetchingSubmission: false,
  isSearching: false,
  isCreating: false,
  isSaving: false,
  isFetchingEZ: false,
  isCanceling: false,
  isPostingHistory: false,
  isUploading: false,
  isFetchingEzClaimStatus: false,
  isFetchingInvalidPrimDxInitials: false,

  result: [],
};

const claimReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_SUBMITTED_CLAIM_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingSubmitted: true,
      };

    case types.GET_SUBMITTED_CLAIM_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingSubmitted: false,
      };

    case types.GET_SUBMITTED_CLAIM_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingSubmitted: false,
      };

    case types.GET_CLAIM_SUBMISSION_FILE_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingSubmission: true,
      };

    case types.GET_CLAIM_SUBMISSION_FILE_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingSubmission: false,
      };

    case types.GET_CLAIM_SUBMISSION_FILE_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingSubmission: false,
      };

    case types.SEARCH_CLAIMS_REQUEST:
      return {
        ...state,
        result: [],
        isSearching: true,
      };

    case types.SEARCH_CLAIMS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isSearching: false,
      };

    case types.SEARCH_CLAIMS_FAILURE:
      return {
        ...state,
        result: [],
        isSearching: false,
      };

    case types.CREATE_CLAIM_REQUEST:
      return {
        ...state,
        result: [],
        isCreating: true,
      };

    case types.CREATE_CLAIM_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isCreating: false,
      };

    case types.CREATE_CLAIM_FAILURE:
      return {
        ...state,
        result: [],
        isCreating: false,
      };

    case types.SAVE_CLAIM_REQUEST:
      return {
        ...state,
        result: [],
        isSaving: true,
      };

    case types.SAVE_CLAIM_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isSaving: false,
      };

    case types.SAVE_CLAIM_FAILURE:
      return {
        ...state,
        result: [],
        isSaving: false,
      };

    case types.GET_EZ_CLAIM_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingEZ: true,
      };

    case types.GET_EZ_CLAIM_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingEZ: false,
      };

    case types.GET_EZ_CLAIM_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingEZ: false,
      };

    case types.GET_EZ_CLAIM_STATUS_REQUEST:
      return {
        ...state,
        isFetchingEzClaimStatus: true,
      };

    case types.GET_EZ_CLAIM_STATUS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingEzClaimStatus: false,
      };

    case types.GET_EZ_CLAIM_STATUS_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingEzClaimStatus: false,
      };

    case types.CANCEL_CLAIM_REQUEST:
      return {
        ...state,
        result: action.payload,
        isCanceling: true,
      };

    case types.CANCEL_CLAIM_SUCCESS:
      return {
        ...state,
        result: [],
        isCanceling: false,
      };

    case types.CANCEL_CLAIM_FAILURE:
      return {
        ...state,
        result: [],
        isCanceling: false,
      };

    case types.POST_CLAIM_HISTORY_REQUEST:
      return {
        ...state,
        result: action.payload,
        isPostingHistory: true,
      };

    case types.POST_CLAIM_HISTORY_SUCCESS:
      return {
        ...state,
        result: [],
        isPostingHistory: false,
      };

    case types.POST_CLAIM_HISTORY_FAILURE:
      return {
        ...state,
        result: [],
        isPostingHistory: false,
      };

    case types.UPLOAD_CLAIM_ATTACHMENT_REQUEST:
      return {
        ...state,
        result: action.payload,
        isUploading: true,
      };

    case types.UPLOAD_CLAIM_ATTACHMENT_SUCCESS:
      return {
        ...state,
        result: [],
        isUploading: false,
      };

    case types.UPLOAD_CLAIM_ATTACHMENT_FAILURE:
      return {
        ...state,
        result: [],
        isUploading: false,
      };

    case types.GET_INVALID_PRIM_DX_INITIALS_REQUEST:
      return {
        ...state,
        isFetchingInvalidPrimDxInitials: true,
      };

    case types.GET_INVALID_PRIM_DX_INITIALS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingInvalidPrimDxInitials: false,
      };

    case types.GET_INVALID_PRIM_DX_INITIALS_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingInvalidPrimDxInitials: false,
      };

    default:
      return state;
  }
};

export default claimReducer;
